import { Fragment } from 'react';
import { cardSrc, parseMogamboCards } from './resultParsers';

export default function MogamboResult({ detail }) {
  const cards = parseMogamboCards(detail?.card);
  // rdesc = "<winner>#<total>" (e.g. "Mogambo#14")
  const rdescParts = String(detail?.rdesc || '').split('#');
  const total = rdescParts[1] || '';
  const mogamboWinner = detail?.winnat || rdescParts[0] || '';
  // winnat "Daga/Teja" (bina spaces) ya "Daga / Teja" dono match kare
  const isDagaWinner = /daga|teja/i.test(mogamboWinner);
  const isMogamboWinner = /mogambo/i.test(mogamboWinner);

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {isDagaWinner && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Daga / Teja</h4>
                {cards.dagaTeja.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="casino-result-content-diveder"></div>
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {isMogamboWinner && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Mogambo</h4>
                {cards.mogambo.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{mogamboWinner || (isDagaWinner ? 'Daga / Teja' : isMogamboWinner ? 'Mogambo' : '')}</div>
          </div>
          {total && (
            <div className="casino-result-desc-item">
              <div>Total</div>
              <div>{total}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
